import React from 'react';

import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { IDataSourceDetailInfo } from '~src/datasource/models/IDataSourceInfo';
import { createExtractRefresh } from '~src/extractRefresh/actions/extractRefresh/CreateExtractRefreshAction';
import { createRemoteExtractRefresh } from '~src/extractRefresh/actions/remoteExtractRefresh/CreateRemoteExtractRefreshAction';
import { NewExtractRefreshButton } from '~src/extractRefresh/components/extractRefresh/CreateExtractRefreshButton';
import { CreateExtractTasksMode } from '~src/extractTask/actions/CreateExtractTaskAction';
import { DisplayMode } from '~src/sessionManagement/serverApi/types/ISessionInfo';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ConnectedCreateContentButton } from '~src/spacesPlatform/components/Explorer/CreateContent/ConnectedCreateContentButton';
import { CreateContentButtonOwnProps } from '~src/spacesPlatform/components/Explorer/CreateContent/CreateContentButton';
import { ExplorerToolbarVisibility } from '~src/spacesPlatform/components/Explorer/Explorer';
import { ContentSpecificControls } from '~src/spacesPlatform/components/Explorer/ExplorerToolbar';
import { ExplorerEmptyStateProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerEmpyState';
import { IRefreshExtractAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { SubspaceName } from '../../state/SpaceInfo';
import { Subspace } from './TabbedSpace';

export interface SubspaceParams {
  name: SubspaceName;
  tabLabel: string;
  supportedDisplayModes: ReadonlyArray<DisplayMode>; // TODO this should come from ExplorableItemTypeDefinition?
  shouldRenderContentCount: boolean;
  contentCount?: number;
  contentCountUpToDate?: boolean;
  toolbarContentFilterControl?: JSX.Element;
  toolbarContentSpecificControls?: ContentSpecificControls;
  supportFilterPanel?: boolean;
  hideSelection?: boolean;
  hideSelectionAndActionMenu?: boolean;
  toolbarVisibility: ExplorerToolbarVisibility;
  emptyStateProps?: ExplorerEmptyStateProps;
  shouldRenderContent?: boolean;
}

export function explorerSubspace(params: SubspaceParams): Subspace {
  return {
    name: params.name,
    tabLabel: params.tabLabel,
    tabContentCount: params.contentCount,
    shouldRenderTabContentCount: params.shouldRenderContentCount,
    tabContentCountUpToDate: params.contentCountUpToDate,
    renderContent: () => {
      if (params.shouldRenderContent === undefined || params.shouldRenderContent) {
        return <ConnectedExplorer
          supportedDisplayModes={params.supportedDisplayModes}
          hideSelectionAndActionMenu={params.hideSelectionAndActionMenu}
          toolbarProps={{
            supportFilterPanel: params.supportFilterPanel,
            hideSelection: params.hideSelection,
            toolbarContentSpecificControls: params.toolbarContentSpecificControls,
            toolbarVisibility: params.toolbarVisibility,
            toolbarContentFilterControl: params.toolbarContentFilterControl,
          }}
          emptyStateProps={params.emptyStateProps}
        />;
      } else {
        return null;
      }
    }
  };
}

export function newExtractRefreshButton(
  content: IContentInfo,
  actions: IRefreshExtractAction,
  disabled?: boolean
): JSX.Element {
  const appState = getAppStore().getState();

  if (currentUserIsOwnerOrAdmin(appState, content)) {
    const taskMode = getSessionManagementServiceInstance().isOnlineEnvironment() ?
      CreateExtractTasksMode.AllowScheduleOnServerAndClient : CreateExtractTasksMode.AllowScheduleOnServer;
    const action = createExtractRefresh([content], taskMode);
    return <NewExtractRefreshButton handleClick={() => getAppStore().dispatch(action)}
      disabled={disabled} />;
  }

  return null;
}

export function newRemoteExtractRefreshButton(
  datasource: IDataSourceDetailInfo
): JSX.Element {
  const appState = getAppStore().getState();

  if (currentUserIsOwnerOrAdmin(appState, datasource)) {
    const action = createRemoteExtractRefresh(datasource);
    return <NewExtractRefreshButton handleClick={() => getAppStore().dispatch(action)} />;
  }

  return null;
}

export function createContentButton(ownProps?: CreateContentButtonOwnProps): JSX.Element {
  return <ConnectedCreateContentButton {...ownProps} />;
}
